module.exports = __webpack_public_path__ + "static/media/hear_results_3.0a4826b8.jpg";